import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const PrivateRoute = ({ children, requiredRole }) => {
  const { currentUser, loading, isAdmin } = useAuth();

  // If auth is still loading, show a loading indicator
  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p>Loading...</p>
      </div>
    );
  }

  // If user is not authenticated, redirect to login
  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  // If a specific role is required, check if user has that role
  if (requiredRole === 'admin' && !isAdmin()) {
    return <Navigate to="/client" replace />;
  }

  // Render the protected component
  return children;
};

export default PrivateRoute;
